import React from 'react'
import { AlertProps } from '@mui/material'
import { Body1, Body1Bold } from '../../../components/Typography'
import { Flex, InnerBoxText } from '../../../components/Flex'
import { AddUserForm } from '../../settings/AddUserForm'
import { Role } from '../../../graphql/generated'
import { Link } from '../../../components/Link'
import { getAccountingRolesMap } from '../../../utils/roles'
import { colors, spacing } from '../../../theme'

interface Props {
  setSnackbar: React.Dispatch<
    React.SetStateAction<Pick<AlertProps, 'children' | 'severity'> | null>
  >
  goToNextStep: () => void
}
export function InviteAccountantStep({
  goToNextStep,
  setSnackbar,
}: Props): React.JSX.Element {
  const setError = (error: string) => {
    setSnackbar({
      children: error,
      severity: 'error',
    })
  }

  return (
    <>
      <InnerBoxText>
        <Body1Bold data-testid='accountant-step'>
          Bjud in din ekonomiadministratör
        </Body1Bold>
        <Body1>
          För att Svalna ska kunna analysera ert klimatavtryck behöver vi få
          tillgång till bokföringsdata i Fortnox. Den person hos er som har
          bokföringslicensen (oftast en ekonomiadministratör eller revisor)
          behöver bara logga in och godkänna villkoren. Sedan hämtar Svalna
          automatiskt bokföringsdatan och påbörjar analysen.
        </Body1>
        <Body1>
          Fyll i formuläret nedan för att bjuda in administratören. När du
          klickar på Fortsätt skickar vi all nödvändig information via e-post.
        </Body1>
        <Body1>
          Om du själv har rätt licens i Fortnox, se till att inställningarna är
          korrekta enligt dokumentationen nedan och ladda sedan om sidan för att
          fortsätta.
        </Body1>
        <Body1>
          <span>Läs mer om behörighet och inställningar i Fortnox i vår</span>{' '}
          <Link
            href='https://svalna.gitlab.io/business-intelligence-frontend/permissions'
            target='_blank'
            rel='noreferrer'
          >
            dokumentation
          </Link>
          <span>.</span>
        </Body1>
      </InnerBoxText>
      <Flex
        stretchWidth
        style={{
          borderTop: `1px solid ${colors.gray}`,
          paddingTop: spacing.medium,
        }}
      >
        <AddUserForm
          setError={setError}
          roleOptions={getAccountingRolesMap()}
          defaultRole={Role.Accountant}
          onSuccess={() => goToNextStep()}
          buttonText='FORTSÄTT'
          setSnackbar={setSnackbar}
          context='accountant-step'
        />
      </Flex>
    </>
  )
}
